// src/utils/impactScorecardPdf.js
// Fill the blank scorecard template (in public/) with field values and hand
// back PDF bytes; plus a browser download helper. Runs entirely client-side.
import { PDFDocument } from "pdf-lib";

const TEMPLATE_URL = `${process.env.PUBLIC_URL || ""}/impact-scorecard-template.pdf`;

export async function fillScorecardPdf(fields) {
  const res = await fetch(TEMPLATE_URL);
  if (!res.ok) throw new Error(`Scorecard template not found (${res.status})`);
  const bytes = await res.arrayBuffer();
  const pdfDoc = await PDFDocument.load(bytes);
  const form = pdfDoc.getForm();
  Object.entries(fields || {}).forEach(([name, value]) => {
    try {
      form.getTextField(name).setText(value == null ? "" : String(value));
    } catch (err) {
      // Field renamed or absent in this template — skip it, fill the rest.
    }
  });
  return pdfDoc.save();
}

export function downloadBytes(bytes, filename) {
  const blob = new Blob([bytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
